import { render, staticRenderFns } from "./Badges.vue?vue&type=template&id=b7c82a00&scoped=true"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"
import style0 from "./Badges.vue?vue&type=style&index=0&id=b7c82a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c82a00",
  null
  
)

export default component.exports